import { render, staticRenderFns } from "./sidesheet.vue?vue&type=template&id=48d4daf0&scoped=true&"
import script from "./sidesheet.vue?vue&type=script&lang=js&"
export * from "./sidesheet.vue?vue&type=script&lang=js&"
import style0 from "./sidesheet.vue?vue&type=style&index=0&id=48d4daf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4daf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d4daf0')) {
      api.createRecord('48d4daf0', component.options)
    } else {
      api.reload('48d4daf0', component.options)
    }
    module.hot.accept("./sidesheet.vue?vue&type=template&id=48d4daf0&scoped=true&", function () {
      api.rerender('48d4daf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidesheet.vue"
export default component.exports